import type { ShopGuideVideo } from '@/lib/api/shop-guide-videos-api'

export interface GuideVideoGroup {
    name: string
    items: ShopGuideVideo[]
}

/** Gom theo nhóm, giữ thứ tự server; nhóm xếp theo video đầu tiên của nhóm. */
export function groupGuideVideos(list: ShopGuideVideo[]): GuideVideoGroup[] {
    const groups = new Map<string, ShopGuideVideo[]>()
    for (const v of list) {
        const items = groups.get(v.group_name)
        if (items) items.push(v)
        else groups.set(v.group_name, [v])
    }
    return [...groups].map(([name, items]) => ({ name, items }))
}

/** 197 → "3:17", 3723 → "1:02:03"; chưa biết → "". */
export function formatGuideDuration(seconds: number | null | undefined) {
    if (seconds == null) return ''
    const s = Math.max(0, Math.round(seconds))
    const h = Math.floor(s / 3600)
    const mm = Math.floor((s % 3600) / 60)
    const ss = String(s % 60).padStart(2, '0')
    return h > 0 ? `${h}:${String(mm).padStart(2, '0')}:${ss}` : `${mm}:${ss}`
}

/** Khoá so khớp tên nhóm như server (foldVi + gộp khoảng trắng): bỏ dấu, đ→d, chữ thường. */
function groupKey(s: string) {
    return s
        .normalize('NFD')
        .replace(/\p{Mn}/gu, '')
        .replace(/[đĐ]/g, 'd')
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .join(' ')
}

/** Hai tên nhóm chỉ khác dấu / hoa thường / khoảng trắng. */
export function sameGroupName(a: string, b: string) {
    return groupKey(a) === groupKey(b)
}
